import script from "./PageDescriptionEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PageDescriptionEditor.vue?vue&type=script&setup=true&lang=js"

import "./PageDescriptionEditor.vue?vue&type=style&index=0&id=4bf651d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf651d0"]])

export default __exports__